import React from 'react'
import { Controller } from 'react-hook-form'
import { FormFeedback, Input, Label } from 'reactstrap'

const InputText = ({
  label,
  options,
  errors,
  required = false,
  isUpperCase = false
}) => {

  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        {label}
      </Label>
      <Controller
        control={options.control}
        id={options.id}
        name={options.name}
        render={({ field }) => (
          <Input
            data-type="text"
            type="text"
            placeholder=""
            disabled={options.disabled}
            invalid={errors[options.name] && true}
            {...field}
            onChange={(e) => {
              let upperCaseText = isUpperCase ? e.target.value.toUpperCase() : e.target.value // Convertir a mayúsculas
              // Permite punto y coma: nombres de sociedad (S.A. de C.V.) y
              // direcciones los necesitan - sin esto se guardaban sin ellos.
              upperCaseText = upperCaseText.replace(/[^A-ZÁÉÍÓÚÜÑ0-9\s&\/\-.,]/gi, '')
              upperCaseText = upperCaseText.replace(/\s{2,}/g, ' ') // Elimina espacios duplicados
              if (upperCaseText[0] === ' ') {
                upperCaseText = upperCaseText.trim()
              }
              field.onChange({
                ...e,
                target: {
                  ...e.target,
                  value: upperCaseText
                }
              })
              // e.target.value = e.target.value.replace(/[^A-Za-z\s]/gi, '')
              // e.target.value = e.target.value.replace(/\s{2,}/g, ' ')
              if (e.target.value[0] === ' ') {
                e.target.value = e.target.value.trim()
              }
              // field.onChange(e)
            }}
            required={required}
          />
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name].message}</FormFeedback>
      )}
    </React.Fragment>
  )
}

export default InputText
